import TokensService from '@omni/kit/services/TokensService';

import Environment from '../../../Environment';
import BaseService, { IHttpResponse, IUri, buildUrl } from '../../BaseService';
import { IGroupMembers } from '../Types';

const RESOURCE = 'group-member';

interface IGetGroupMembers extends Omit<IUri, 'resource'> {
  filters: [string, string][];
  pages?: [string, number][];
  token?: string;
}

interface IGetGroupMembersResponse extends IHttpResponse {
  body?: IGroupMembers;
}

export default async ({
  filters,
  pages,
  token,
}: IGetGroupMembers): Promise<IGetGroupMembersResponse> => {
  const url = buildUrl({
    host: Environment.groupsHost,
    filters: filters,
    pages: pages,
    includes: ['end-user', 'end-user.profiles', 'end.user.profiles.image'],
    resource: RESOURCE,
  });

  return BaseService.Get({
    url,
    token: token,
    skipTimestamp: true,
    headers: {
      'Collection-Total': 'include',
    },
  });
};
